import CXMApiClient from "../../CXMApiClient";
import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";
function initialState() {
  return {
    CustomerProfileSnapshot: [],
    tempData: {
      data: {
        activeLeadTasks: [
          {
            leadTaskId: 177124,
            taskStatus: 2,
            name: "Start conatct with prospect",
            taskDueDate: "2020-01-28T21:05:30.881117+00:00"
          },
          {
            leadTaskId: 177125,
            taskStatus: 1,
            name: "Schedule Appointment",
            taskDueDate: "2020-01-28T21:05:30.881117+00:00"
          },
          {
            leadTaskId: 177128,
            taskStatus: 4,
            name: "Send Email",
            taskDueDate: "2020-01-28T21:05:30.881117+00:00"
          },
          {
            leadTaskId: 177158,
            taskStatus: 3,
            name: "Update customer dealsheet",
            taskDueDate: "2020-01-28T21:05:30.881117+00:00"
          },
          {
            leadTaskId: 177788,
            taskStatus: 5,
            name: "Closed Deal with customer",
            taskDueDate: "2020-01-28T21:05:30.881117+00:00"
          }
        ],
        activeProcesses: [
          {
            workflowInstanceId: "10:YAMgLANXNGXc",
            stepInstanceId: "10:D7iZUct1es37",
            workflowInstanceTitle: "HASSAN Notification Test",
            workflowInstanceStatus: "150",
            stepInstanceName: "Step 1",
            claimedByUserIds: [
              "10:11TBPIq",
              "10:Dsyp8mExpjQu",
              "10:EGPYgpHmctfY",
              "10:1ZVZYhASYuIe"
            ]
          }
        ],
        lastContact: 2,
        lastContactDate: "2019-11-06T15:51:31.838992+00:00",
        nextScheduledActivity: 2,
        nextScheduledActivityDate: "2019-11-06T15:51:31.838992+00:00",
        lastServiceVisit: "2019-04-20T13:53:00",
        lastCustomerEngagement: 1,
        lastCustomerEngagementDate: "2020-01-28T21:05:30.881117+00:00"
      },
      pageData: null,
      errorMessages: [],
      statusCode: 200,
      successful: true
    }
  };
}

const state = initialState();

const getters = {
  CustomerProfileSnapshot: function() {
    return state.CustomerProfileSnapshot; // state.tempData.data;
  }
};

const actions = {
  getCustomerProfileSnapshot: function(context, filter) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    let request = {
      entityIds: filter.EntitityId ? [filter.EntitityId] : []
    };
    return new Promise((resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest(
          "post",
          "/crm/contacts/" + filter.ContactId + "/snapshot",
          request, scope
        )
        .then(response => {
          if (response && response.data.successful) {
            context.commit("updateCustomerProfileSnapshot", response.data.data);
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};

const mutations = {
  updateCustomerProfileSnapshot: function(state, data) {
    state.CustomerProfileSnapshot = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/customerdashboard/Snapshot.js